import { AlgoPermissions } from "../../../../../../../../../utProto/webEnums_pb";

export const AlgoPermissionMapping = {
    'External Strategy': AlgoPermissions.WEBALGOPERMISSION_EXTERNALSTRATEGY,
    'uTrade Originals': AlgoPermissions.WEBALGOPERMISSION_UTRADEORIGINALS,
    'Margin Calculator': AlgoPermissions.WEBALGOPERMISSION_MARGINCALCULATOR,
    'Payoff Curve': AlgoPermissions.WEBALGOPERMISSION_PAYOFFCURVE,
    'Concurrent Backtest': AlgoPermissions.WEBALGOPERMISSION_CONCURRENTBT,
    'Relationship Manager': AlgoPermissions.WEBALGOPERMISSION_RELATIONSHIPMANAGER,
    'Custom Allowed': AlgoPermissions.WEBALGOPERMISSION_CUSTOMALGOS,
    'Copy Allowed': AlgoPermissions.WEBALGOPERMISSION_COPYALGOALLOWED,
    'Show Portfolio': AlgoPermissions.WEBALGOPERMISSION_HIDECUSTOMPORTFOLIO,
    'Download/Upload Portfolio': AlgoPermissions.WEBALGOPERMISSION_DOWNLOADUPLOADPORTFOLIO,
    'Intraday': AlgoPermissions.WEBALGOPERMISSION_INTRADAY,
    'CarryForward': AlgoPermissions.WEBALGOPERMISSION_CARRYFORWARD,
    'AI Assistant Strategist': AlgoPermissions.WEBALGOPERMISSION_AIASSISTANT_STRATEGIST,
    'AI Assistant Advisor': AlgoPermissions.WEBALGOPERMISSION_AIASSISTANT_ADVISOR,
    'AI Recommned Originals': AlgoPermissions.WEBALGOPERMISSION_AIRECOMMEND_ORIGINALS,
    'uTrade ONE AI': AlgoPermissions.WEBALGOPERMISSION_AIASSISTANT_ONEAI,
    'NSECM CarryForward': AlgoPermissions.WEBALGOPERMISSION_NSECM_CARRYFORWARD,
    'NSECM Intraday': AlgoPermissions.WEBALGOPERMISSION_NSECM_INTRADAY,
    'BSECM CarryForward': AlgoPermissions.WEBALGOPERMISSION_BSECM_CARRYFORWARD,
    'BSECM Intraday': AlgoPermissions.WEBALGOPERMISSION_BSECM_INTRADAY,
    'NSEFO CarryForward': AlgoPermissions.WEBALGOPERMISSION_NSEFO_CARRYFORWARD,
    'NSEFO Intraday': AlgoPermissions.WEBALGOPERMISSION_NSEFO_INTRADAY,
    'BSEFO CarryForward': AlgoPermissions.WEBALGOPERMISSION_BSEFO_CARRYFORWARD,
    'BSEFO Intraday': AlgoPermissions.WEBALGOPERMISSION_BSEFO_INTRADAY,
}

export const AlgoPermissionMappingRev = {
    [AlgoPermissions.WEBALGOPERMISSION_EXTERNALSTRATEGY]: 'External Strategy',
    [AlgoPermissions.WEBALGOPERMISSION_UTRADEORIGINALS]: 'uTrade Originals', 
    [AlgoPermissions.WEBALGOPERMISSION_MARGINCALCULATOR]: 'Margin Calculator', 
    [AlgoPermissions.WEBALGOPERMISSION_PAYOFFCURVE]: 'Payoff Curve', 
    [AlgoPermissions.WEBALGOPERMISSION_CONCURRENTBT]: 'Concurrent Backtest', 
    [AlgoPermissions.WEBALGOPERMISSION_RELATIONSHIPMANAGER]: 'Relationship Manager',
    [AlgoPermissions.WEBALGOPERMISSION_CUSTOMALGOS]: 'Custom Allowed',
    [AlgoPermissions.WEBALGOPERMISSION_COPYALGOALLOWED]: 'Copy Allowed',
    [AlgoPermissions.WEBALGOPERMISSION_HIDECUSTOMPORTFOLIO]: 'Show Portfolio',
    [AlgoPermissions.WEBALGOPERMISSION_DOWNLOADUPLOADPORTFOLIO]: 'Download/Upload Portfolio',
    [AlgoPermissions.WEBALGOPERMISSION_AIASSISTANT_STRATEGIST]: 'AI Assistant Strategist',
    [AlgoPermissions.WEBALGOPERMISSION_AIASSISTANT_ADVISOR]: 'AI Assistant Advisor',
    [AlgoPermissions.WEBALGOPERMISSION_AIRECOMMEND_ORIGINALS]: 'AI Recommned Originals',
}

